module.exports = __webpack_public_path__ + "img/bx_bx-plus-circle.2065cc58.svg";